exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FICLink{line-height:30px;height:auto}.FICLink a{cursor:pointer}.FICLink.FICLink-disabled a{pointer-events:none;cursor:not-allowed;color:#b1b1b1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/common/components/css/FICLink.css
// module id = 108
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 26 27 32 33 34 37 50